<template>
	<div v-if="hasPermission">
		<ContentBalanceSheet />
	</div>
</template>

<script>
// @ is an alias to /src
import ContentBalanceSheet from '@/components/content/content-acc/ContentBalanceSheet.vue'
import { getPermissions } from '../components/util/liblist'
export default {
	name: 'BalanceSheet',
	components: {
		ContentBalanceSheet,
	},
	data() {
		return {
			'hasPermission': false, 
		}
	},
	mounted() {
		if (getPermissions('accounting.report.balancesheet')) {
			this.hasPermission = true
		}
	},
	computed: {
		
	},
	methods: {

	},
}
</script>
